import { Checkbox, Group, Select, Stack, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

import { ProductEnum } from '@/api';

import { PRODUCT_TYPE_FILTER_OPTIONS } from './constants';
import { productTypeLabel } from './helpers';
import type { MenuRestaurant } from './types';

type MenusPageHeaderProps = {
  restaurants: MenuRestaurant[];
  selectedVendorId: string | null;
  onVendorChange: (vendorId: string) => void;
  productTypes: ProductEnum[];
  onProductTypesChange: (productTypes: ProductEnum[]) => void;
};

export const MenusPageHeader: React.FC<MenusPageHeaderProps> = ({
  restaurants,
  selectedVendorId,
  onVendorChange,
  productTypes,
  onProductTypesChange,
}) => {
  const options = restaurants.map((restaurant) => ({
    value: restaurant.id,
    label: restaurant.name,
  }));

  return (
    <Stack
      bg="gray.0"
      px="lg"
      py="md"
      flex="0 0 auto"
      style={{ borderBottom: '1px solid var(--mantine-color-gray-3)' }}
    >
      <Group gap="xl" wrap="wrap" align="center">
        <Group gap="sm" wrap="nowrap" align="center">
          <Text size="sm" fw={600}>
            Restaurant
          </Text>
          <Select
            data={options}
            value={selectedVendorId}
            onChange={(value) => value && onVendorChange(value)}
            placeholder="Select a restaurant"
            rightSection={<IconChevronDown size={16} />}
            allowDeselect={false}
            searchable={options.length > 8}
            nothingFoundMessage="No restaurants"
            disabled={options.length === 0}
            w={300}
            aria-label="Select a restaurant"
          />
        </Group>

        <Group gap="md" wrap="wrap" align="center">
          <Text size="sm" fw={600}>
            Menus:
          </Text>
          <Checkbox.Group
            value={productTypes}
            onChange={(value) => onProductTypesChange(value as ProductEnum[])}
          >
            <Group gap="lg">
              {PRODUCT_TYPE_FILTER_OPTIONS.map((productType) => (
                <Checkbox
                  key={productType}
                  value={productType}
                  label={productTypeLabel(productType)}
                />
              ))}
            </Group>
          </Checkbox.Group>
        </Group>
      </Group>
    </Stack>
  );
};

